<div class="flex flex-col w-full pt-2 px-4 gap-2">
  <h3 class="text-lg font-semibold">
    {{ '#ARTIKELINFO.DIALOGS.ADD_FAVORITE_LIST.TITLE' | translate }}
  </h3>
  <soft-input
    [value]="listName$ | async"
    (valueChange)="listName$.next($event ?? '')"
    [placeholder]="'#ARTIKELINFO.DIALOGS.ADD_FAVORITE_LIST.NAME_PLACEHOLDER' | translate"
  ></soft-input>
</div>

<div class="w-full flex justify-between mt-4">
  <button class="soft-button secondary w-full !h-12" (click)="close(null)">
    {{ '#ARTIKELINFO.DIALOGS.ADD_FAVORITE_LIST.CANCEL' | translate }}
  </button>
  <button
    class="soft-button primary w-full !h-12"
    (click)="createList()"
    [disabled]="(validListName$ | async) === false"
  >
    {{ '#ARTIKELINFO.DIALOGS.ADD_FAVORITE_LIST.ADD' | translate }}
  </button>
</div>
